import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as primeng from 'primeng/primeng';

import { AppTopBar } from './app.topbar.component';
import { SharedModule } from './shared/shared.module';
import { FormsModule } from '@angular/forms';
import { OverlayPanelModule } from 'primeng/primeng';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    primeng.DropdownModule,
    primeng.StepsModule,
    primeng.DialogModule,
    //CursoPrestacaoContaModule,
    SharedModule,
    OverlayPanelModule
  ],
  declarations: [
    AppTopBar,
    //PadraoService,
    //CrudCursoPrestacaoContaComponent,
    //CrudEventoPrestacaoContaComponent,
    //FormatSelectItemPipe,
  ],
  exports: [
    AppTopBar
  ]
})
export class AppTopBarModule { }



// WEBPACK FOOTER //
// ./src/app/app.topbar.module.ts